module.exports = __webpack_public_path__ + "static/media/arrow_right.9408db55.svg";